import { Model } from "@type-r/models";
import {  define } from "@type-r/models";
import { fetchJson, restfulIO } from "api/endpoint";


@define
export class EmbeddedConfig extends Model {

    static endpoint = restfulIO('api/bi/embedconfig');

    static attributes = {
        token : String,
        embedURL : String
    }
    embedURL: string;
    token : string;
  //  models: any;

    
}
export async function getEmbeddedConfig(reportId: String, platformCode: string): Promise<EmbeddedConfig> {
    const url =  `api/bi/embedconfig/${platformCode}/${reportId}`;
    return await fetchJson('GET', url);
}

